import { type PayoutOrder } from '~/entities/payout';
import { type OrderOrigin } from '~/shared/lib/orderRoutes';
import { type TableData } from '~/shared/ui/Table';
import { orderTableHeaders } from './columns';
import { prepareTableRows } from './prepareTableRows';

interface PrepareTableDataProps {
    orders?: PayoutOrder[];
    origin: OrderOrigin;
}

export const prepareTableData = ({ orders, origin }: PrepareTableDataProps): TableData<PayoutOrder> => {
    return {
        head: orderTableHeaders,
        rows: prepareTableRows({ orders, origin }),
        caption: orders?.length === 0 ? 'Ордеров нет' : undefined,
    };
};
